var map = {
	"./de.json": "X30x",
	"./en.json": "C2DJ",
	"./fr.json": "3vIV",
	"./id.json": "i4Fg",
	"./ja.json": "Tyv0",
	"./ko.json": "uyv0",
	"./ms.json": "VAdK",
	"./th.json": "Hs/z",
	"./vi.json": "DlZH",
	"./zh-cn.json": "Jx/7",
	"./zh-hant.json": "52um",
	"./zh-hk.json": "51+m",
	"./zh-tw.json": "r+or"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "qVwb";